module.exports = __webpack_public_path__ + "static/media/goodbricks-logo.c47629f1.svg";